import { parseBirthDate } from './auth.util';
import { MINIMUM_SIGNUP_AGE, GROUP_REQUIRED_AGE_MAX } from '@/constants';

export function calculateAge(birthDate: Date, referenceDate = new Date()): number {
	let age = referenceDate.getFullYear() - birthDate.getFullYear();
	const m = referenceDate.getMonth() - birthDate.getMonth();
	if (m < 0 || (m === 0 && referenceDate.getDate() < birthDate.getDate())) {
		age--;
	}
	return age;
}

export function isGroupRequired(birthDateObj: {
	day: string | number;
	month: string | number;
	year: string | number;
}): boolean {
	const birthDate = parseBirthDate(birthDateObj);
	if (!birthDate) return false;

	const age = calculateAge(birthDate);
	return age >= MINIMUM_SIGNUP_AGE && age <= GROUP_REQUIRED_AGE_MAX;
}
